import { render } from "./Checkbox.vue?vue&type=template&id=68ee0993"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp320\\www\\vicra-lara\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Form/Checkbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68ee0993"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68ee0993', __exports__)) {
    console.log('reload')
    api.reload('68ee0993', __exports__)
  }
  
  module.hot.accept("./Checkbox.vue?vue&type=template&id=68ee0993", () => {
    console.log('re-render')
    api.rerender('68ee0993', render)
  })

}


export default __exports__